import React, { memo } from "react";
import TextInput from "@components/textInput/TextInput";
import { FormikProps } from "formik";
import { AddInitialValueType } from "./components/useAddAndEditChild";

interface PostalCodeProps {
  formik: FormikProps<AddInitialValueType>;
  listPostalCodes?: string[];
  onClickPostalCode?: (x: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PostalCode = ({
  formik,
  listPostalCodes,
  onClickPostalCode,
}: PostalCodeProps) => {
  return (
    <>
      <div className="row g-0">
        <h1 className="pl-3 pr-3 mb-8 forsmElements__inputSectionHeader header--18">
          Pick up & Drop off Address
        </h1>
      </div>
      <TextInput
        title="Postal Code *"
        placeholder="Input Postal Code"
        {...formik.getFieldProps("postalCode")}
        onChange={(event) => {
          formik.setFieldValue("fullAddress", event.target.value);
          formik.setFieldValue("postalCode", event.target.value);
        }}
        list="postalCodes"
        dataList={listPostalCodes}
        error={
          formik.errors.postalCode || formik.errors.lat || formik.errors.lon
        }
        touched={
          formik.touched.postalCode || formik.touched.lat || formik.touched.lon
        }
      ></TextInput>

      <div className="row gx-5">
        <div className="col-sm-6">
          <TextInput
            title="Unit No."
            placeholder="Input Unit No"
            {...formik.getFieldProps("unitNo")}
          ></TextInput>
        </div>
        <div className="col-sm-6 ">
          <TextInput
            title="Block No."
            placeholder="Input Block No"
            {...formik.getFieldProps("blockNo")}
          ></TextInput>
        </div>
      </div>

      <TextInput
        title="Building Name"
        placeholder="Input Building Name"
        {...formik.getFieldProps("buildingName")}
      ></TextInput>

      <TextInput
        title="Street *"
        placeholder="Input Street"
        {...formik.getFieldProps("street")}
        error={formik.errors.street}
        touched={formik.touched.street}
      ></TextInput>

      {(formik.errors.lat && formik.touched.lat) ||
      (formik.errors.lat && formik.touched.lat) ? (
        <div className="formElements__errorText">
          Longitude and Latitude address not found, Please change address
        </div>
      ) : null}
    </>
  );
};

export default memo(PostalCode);
